






























import Vue from 'vue'
import qs from 'qs'
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
import { SET_PARAM } from '~/store/modules/shared/classifieds/search/mutation-types'
import Results from '~/components/car/classifieds/search/map-search/results/Results.vue'
import { CLASSIFIED_SEARCH_NS } from '~/store/modules/shared/classifieds/search/state'
import { USER_AGENT_NS } from '~/store/modules/shared/userAgent/state'

export default Vue.extend({
  components: {
    Results
  },
  props: {
    clusterGeolocation: { type: String, default: null }
  },
  data() {
    return {
      geolocation: null,
      pg: null
    }
  },
  computed: {
    ...mapGetters(USER_AGENT_NS, {
      isMobile: 'isMobile'
    }),
    ...mapState(CLASSIFIED_SEARCH_NS, {
      loadingResults: state => state.loading.results,
      loadingClusterResults: state => state.loading.clusterResults,
      clusterRowsPagination: state => state.clusterPagination,
      params: state => state.params
    }),
    columns(): number {
      return this.isMobile ? 1 : 2
    }
  },
  watch: {
    clusterRowsPagination() {
      if (this.$refs.results) {
        this.$refs.results.setClusterPage(this.clusterRowsPagination.page)
      }
    },
    clusterGeolocation() {
      this.geolocation = this.clusterGeolocation
    },
    params() {
      if (!this.params['show-clusters']?.length) {
        this.$refs.modal.hide()
      }
    }
  },
  beforeMount() {
    if (
      this.params['show-clusters']?.length &&
      this.params?.cgeolocation?.length
    ) {
      this.geolocation = this.params.cgeolocation[0]
      if (this.params.cpg?.length) {
        this.pg = this.params.cpg[0]
      }
    } else {
      this.geolocation = this.clusterGeolocation
      this.setClusterParametes()
    }

    this.searchForClusterResults({
      geolocation: this.geolocation,
      pg: this.pg
    })
  },
  methods: {
    ...mapActions(CLASSIFIED_SEARCH_NS, {
      searchForClusterResults: 'searchForClusterResults',
      updateUrlAndRoutes: 'updateUrlAndRoutes'
    }),
    ...mapMutations(CLASSIFIED_SEARCH_NS, {
      setParam: SET_PARAM
    }),
    onClassifiedClick({ classified }) {
      const { scrollTop } = this.$refs.modal.$refs.body
      this.setParam({ name: 'ccsp', value: scrollTop })
      this.updateUrlWithParams({ ccsp: scrollTop })
      this.$router.push({ path: classified.seoJsonLd.url })
    },
    handlePageChange(pg: number) {
      this.setParam({ name: 'cpg', value: pg })
      this.updateUrlWithParams({ cpg: pg })
      this.searchForClusterResults({
        pg,
        geolocation: this.geolocation
      })
      this.$refs.modal.$refs.body.scrollTo(0, 0)
    },
    updateUrlWithParams(params: object) {
      const { origin, pathname, search } = window.location
      const currentParams = qs.parse(search)
      const url = `${origin}${pathname}${qs.stringify(
        { ...currentParams, ...params },
        {
          indices: false,
          encode: false,
          skipNulls: true
        }
      )}`
      this.updateUrlAndRoutes(url)
    },
    setClusterParametes() {
      this.setParam({ name: 'cgeolocation', value: this.clusterGeolocation })
      this.setParam({ name: 'show-clusters', value: true })
      this.updateUrlWithParams({
        'show-clusters': true,
        cgeolocation: this.clusterGeolocation
      })
    },
    handleHideModal() {
      this.setParam({ name: 'cgeolocation', value: null })
      this.setParam({ name: 'show-clusters', value: null })
      this.setParam({ name: 'cpg', value: null })
      this.setParam({ name: 'ccsp', value: null })
      this.updateUrlWithParams({
        'show-clusters': null,
        cgeolocation: null,
        cpg: null,
        ccsp: null
      })
      this.$emit('hide')
    },
    handleModalShown() {
      if (this.params?.ccsp?.length) {
        this.$refs.modal.$refs.body.scrollTo(0, this.params.ccsp[0])
      }
    }
  }
})
